import { create } from "zustand"

import type {
  Classification,
  ClassificationListQuery,
  ClassificationListSortField,
  SortingOrder,
} from "@/graphql/codegen/graphql"
import { ClassificationListDocument } from "@/graphql/codegen/graphql"
import { type SearchFilters, createSearchStore } from "@/stores/createSearchStore"

export type ClassificationsSearchFilters = SearchFilters & {
  field: ClassificationListSortField
  order: SortingOrder
}

const deduplicateInstructions = (newData: Classification[], existingData: Classification[]): Classification[] => {
  const uniqueIds = new Set(existingData.map((classification) => classification.classificationId))
  return [...existingData, ...newData.filter((classification) => !uniqueIds.has(classification.classificationId))]
}

export const useClassificationsSearchStore = create(
  createSearchStore<Classification, ClassificationsSearchFilters, ClassificationListQuery>({
    documentNode: ClassificationListDocument,
    deduplicateData: deduplicateInstructions,
    getQueryInput: (filters: ClassificationsSearchFilters, offset: number, limit: number) => {
      const { field, order, ...otherFilters } = filters
      return {
        filter: otherFilters,
        offset,
        limit,
        sort: { field, order },
      }
    },
    getQueryVariables: (queryInput) => ({ input: queryInput }),
    extractDataFromResponse: (data) => ({
      __typename: data.classification.list.__typename,
      data:
        data.classification.list.__typename === "ClassificationListSuccess"
          ? (data.classification.list.classifications as Classification[])
          : [],
      error:
        data.classification.list.__typename === "ClassificationListFailure"
          ? data.classification.list.error
          : undefined,
    }),
  })
)
